import { render, staticRenderFns } from "./DeletePatientConfirm.vue?vue&type=template&id=6334bd00&scoped=true&"
import script from "./DeletePatientConfirm.vue?vue&type=script&lang=js&"
export * from "./DeletePatientConfirm.vue?vue&type=script&lang=js&"
import style0 from "./DeletePatientConfirm.vue?vue&type=style&index=0&id=6334bd00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6334bd00",
  null
  
)

export default component.exports